import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Text } from '@rsos/base-components';
import { AlertLocationCivic } from '@rsos/reduxDataStore/src/features/alerts/alerts.types';
import { getCopyableCivicAddress } from '@rsos/utils/getCopyableCivicAddress';
import { HoveredCopyButton } from '../../HoveredButtons';
import { handleSetIsCopiedTimer } from '../../HoveredButtons/helpers';
import {
  Address,
  AddressBox,
  CopyableLocation,
  LocationText,
} from './DataCardLocation.styles';
import { NoAddress } from './NoAddress';
import { trackCopyAlertAddress } from './alertLocationTrackings';
import { getTopAddress } from './helpers';

interface LocationAddressInterface {
  isHistoricLocation?: boolean;
  civic: AlertLocationCivic;
  isLocationRestricted?: boolean;
}

const LocationAddress = ({
  civic,
  isHistoricLocation,
  isLocationRestricted,
}: LocationAddressInterface) => {
  const [isCopied, setIsCopied] = useState(false);
  const selectedAlertID = useSelector(
    // TODO: replace any with a better type
    (state: any) => state.incidents.selectedAlertID,
  );

  // TODO: replace any with a better type
  const irpVersion = useSelector((state: any) => state.sinatra.irp.irpVersion);

  const { street_1, street_2, city, state, zip_code } = civic;

  const noAddress = !street_1 && !street_2 && !city && !state;
  const TopAddress = getTopAddress(street_1, street_2);

  const onClick = () => {
    trackCopyAlertAddress(selectedAlertID, irpVersion);
    handleSetIsCopiedTimer(setIsCopied);
  };

  return (
    <AddressBox
      mb={isHistoricLocation ? '0px' : '8px'}
      data-name="location-address"
    >
      {isLocationRestricted && (
        <LocationText fontWeight="bold">Location Restricted</LocationText>
      )}
      {noAddress && !isLocationRestricted && <NoAddress />}
      {!noAddress && !isLocationRestricted && (
        <CopyableLocation
          isCopied={isCopied}
          isHistoricLocation={isHistoricLocation}
        >
          <Address>
            {TopAddress}
            <Text marginTop="4px" size="large">
              {city}, {state} {zip_code}
            </Text>
          </Address>
          <HoveredCopyButton
            copyableText={getCopyableCivicAddress(civic)}
            handleClick={onClick}
            top="0"
          />
        </CopyableLocation>
      )}
    </AddressBox>
  );
};

export default LocationAddress;
